import { location } from 'cdui-js';

/** 与 App WebView 打开 H5 时 URL 上 `platform` 等参数对齐（见 RN `W8benFeature` 等） */
const APP_EMBED_PLATFORMS = new Set(['rn', 'app', 'expo', 'native']);

const EMBED_QUERY_KEYS = ['platform', 'embed', 'embedded', 'version'] as const;

export function isW8benEmbeddedInApp(): boolean {
  const q = location.query as Record<string, string | undefined>;
  const platform = (q.platform ?? '').toLowerCase().trim();
  if (platform && APP_EMBED_PLATFORMS.has(platform)) return true;
  if (q.embed === '1' || q.embedded === '1') return true;
  return false;
}

/** 下一跳 URL 上保留当前页的内嵌标记，避免问卷 → 结果页后丢失 */
export function w8benUrlKeepEmbed(nextPathWithQuery: string): string {
  const q = location.query as Record<string, string | undefined>;
  const qm = nextPathWithQuery.indexOf('?');
  const path = qm === -1 ? nextPathWithQuery : nextPathWithQuery.slice(0, qm);
  const existing = qm === -1 ? '' : nextPathWithQuery.slice(qm + 1);
  const params = new URLSearchParams(existing);
  for (const key of EMBED_QUERY_KEYS) {
    const v = q[key];
    if (v != null && String(v) !== '' && !params.has(key)) params.set(key, String(v));
  }
  const s = params.toString();
  return s ? `${path}?${s}` : path;
}
